import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { signIn, signOut } from "next-auth/react";
import { useAuth } from "../Auth/AuthContext";
import { Button, Divider, Dropdown, IconButton, LogoutOutlineIcon, SettingsOutlineIcon, SimpleImage } from "@parkschannel/ui";
import { AppNavigation } from "../Layout/components/AppNavigation";
import { useRouter } from "next/router";
import { NavigationLink } from "../Layout/components/NavigationLink";
import classNames from "classnames";
import { useAnalytics, useBlockBodyScroll } from "../../utils";
import { NextAvatar } from "../NextAvatar";
import { useHeader } from "./hooks";
export const Header = ()=>{
    const { onButtonClick  } = useAnalytics();
    const { useSession  } = useAuth();
    const { data: session  } = useSession();
    const { pathname  } = useRouter();
    const [isOpen, setIsOpen] = useState(false);
    useBlockBodyScroll(isOpen);
    const handleToggleMobileMenu = ()=>{
        setIsOpen((prev)=>!prev);
    };
    useEffect(()=>{
        if (isOpen) setIsOpen(false);
    }, [
        pathname
    ]);
    return /*#__PURE__*/ _jsxs("header", {
        className: "w-full flex items-center justify-between ",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "relative z-[91] flex items-center",
                children: [
                    /*#__PURE__*/ _jsx(HamburgerButton, {
                        isOpen: isOpen,
                        toggleMenu: handleToggleMobileMenu
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        href: "https://theparkschannel.com",
                        onClick: ()=>onButtonClick("navigationLogo"),
                        "aria-label": "Go to homepage",
                        children: /*#__PURE__*/ _jsx(SimpleImage, {
                            src: "/TPC-logo.webp",
                            width: 181,
                            height: 52,
                            alt: "The Parks Channel logo"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ _jsx(AppNavigation, {
                        isOpen: isOpen
                    }),
                    session && /*#__PURE__*/ _jsx(HeaderWithSession, {}),
                    !session && /*#__PURE__*/ _jsx(HeaderWithoutSession, {})
                ]
            })
        ]
    });
};
const HeaderWithoutSession = ()=>{
    return /*#__PURE__*/ _jsx(Button, {
        onClick: ()=>signIn("cognito"),
        className: "px-4 md:h-[48px] lg:h-auto lg:py-4 lg:px-6",
        children: "Sign In"
    });
};
const HeaderWithSession = ()=>{
    const { useCurrentUserProfileQuery  } = useHeader();
    const { data: user  } = useCurrentUserProfileQuery();
    return /*#__PURE__*/ _jsx(Dropdown, {
        overlayClassName: "hidden md:block",
        menuItems: [
            /*#__PURE__*/ _jsx("h4", {
                className: "p-2 text-xs text-neutral-900 font-medium",
                children: "My account"
            }),
            /*#__PURE__*/ _jsx(Divider, {
                className: "h-1"
            }),
            /*#__PURE__*/ _jsx(NavigationLink, {
                icon: /*#__PURE__*/ _jsx(SettingsOutlineIcon, {
                    className: "w-5 h-5"
                }),
                href: "/users/me",
                className: "justify-start !text-xs py-2 pl-2 pr-6 hover:bg-neutral-50 transition !rounded-none mt-1",
                children: "Account"
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                variant: "text",
                position: "left",
                size: "sm",
                icon: /*#__PURE__*/ _jsx(LogoutOutlineIcon, {
                    className: "text-red-500 w-5 h-5"
                }),
                onClick: ()=>signOut({
                        callbackUrl: "/api/auth/logout"
                    }),
                className: "!font-semibold !text-red-500 !text-xs w-full !py-2 !pl-2 !pr-6 flex justify-start !rounded-none",
                children: "Sign Out"
            })
        ],
        children: /*#__PURE__*/ _jsx(NextAvatar, {
            src: user === null || user === void 0 ? void 0 : user.avatar_key,
            size: "lg"
        })
    });
};
const HamburgerButton = (param)=>{
    let { isOpen , toggleMenu  } = param;
    return /*#__PURE__*/ _jsxs(Button, {
        onClick: toggleMenu,
        variant: "base",
        className: "relative !shadow-none !drop-shadow-none md:hidden !w-6 !h-6 !p-0 mr-2",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "sr-only",
                children: "Open main menu"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "block w-5 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        "aria-hidden": "true",
                        className: classNames("block absolute h-[1.5px] w-5 bg-neutral-500 transform transition duration-300 ease-in-out", {
                            "rotate-45": isOpen,
                            " -translate-y-1.5": !isOpen
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        "aria-hidden": "true",
                        className: classNames("block absolute  h-[1.5px] w-5 bg-neutral-500 transform transition duration-300 ease-in-out", {
                            "opacity-0": isOpen
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        "aria-hidden": "true",
                        className: classNames("block absolute  h-[1.5px] w-5 bg-neutral-500 transform  transition duration-300 ease-in-out", {
                            "-rotate-45": isOpen,
                            " translate-y-1.5": !isOpen
                        })
                    })
                ]
            })
        ]
    });
};
